import { wrapRetry } from '@perpay-web/utils/importUtils';

export const importRewardsAndCreditsDetailsContainer = () =>
    wrapRetry(
        () =>
            import(
                /* webpackChunkName: "RewardsAndCreditsDetailsContainer" */
                '@perpay-web/fintech/components/containers/RewardsAndCreditsDetailsContainer'
            ),
    );
